import React from 'react'
import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../Context/ThemeContext'

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'
  const label = isDark ? 'Passer au thème clair' : 'Passer au thème sombre'

  return (
    <button
      type="button"
      className={`themeToggle ${className}`}
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDark}
      aria-label={label}
      title={label}
    >
      {isDark ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  )
}

export default ThemeToggle
